import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import MenuItem from '@zenbusiness/zui/MenuItem';
import Select from '@zenbusiness/zui/Select';

import { orderRow } from '../../utils/proptypes';
import OrderHistoryContainer from '../OrderHistoryContainer';

export default function OrderTemplate({
  rows, years, selectedYear, setSelectedYear
}) {
  const trackYearFilterChange = useButtonPressedCallback({
    elementName: 'order_year_filter',
    page: 'order_history'
  });

  const handleChange = (e) => {
    trackYearFilterChange(e, { selectedYear: e.target.value });
    setSelectedYear(e.target.value);
  };

  // build a selector for years
  const selectorItems = years.map((year) => (
    <MenuItem key={year} value={year}>{`${year}`}</MenuItem>
  ));

  // Set initial year when multiple years exist
  useEffect(() => {
    if (years.length > 1 && !selectedYear) {
      setSelectedYear(years[0]);
    }
  }, [years, selectedYear, setSelectedYear]);

  return (
    <>
      {years.length > 1 && (
        <Box minWidth="200px" padding="1rem 0">
          <Select
            data-testid="select-order-year"
            value={selectedYear}
            displayEmpty
            onChange={handleChange}
            inputProps={{ 'aria-label': 'Select Order Years' }}
            sx={{ minWidth: '120px' }}
          >
            <MenuItem value="">
              <em>All Years</em>
            </MenuItem>
            {selectorItems}
          </Select>
        </Box>
      )}
      <OrderHistoryContainer
        selectedYear={selectedYear}
        rows={rows}
      />
    </>
  );
}

OrderTemplate.propTypes = {
  rows: PropTypes.arrayOf(orderRow).isRequired,
  years: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedYear: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  setSelectedYear: PropTypes.func.isRequired
};
